import { AUTH_USER_FRAGMENT } from 'features/user/api/authUser'
import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { gql } from 'providers/tanstack-query/utils'

import type { Data, Variables } from './types'
import type { Ability } from 'providers/casl'
import type { TypedDocumentNode } from 'providers/tanstack-query/types'

export const SIGN_IN = (ability: Ability): TypedDocumentNode<Data, Variables> => gql`
  ${AUTH_USER_FRAGMENT(ability)}
  ${ERROR_FRAGMENT}

  mutation signIn($email: String!, $password: String!) {
    signIn(input: { email: $email, password: $password }) {
      accessToken
      refreshToken

      user {
        ...AuthUserFragment
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
